import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Film, ArrowRight, Sparkles } from 'lucide-react';
import api from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/button';
import { ProjectCard } from './Projects';

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 18) return 'Good afternoon';
  return 'Good evening';
}

export default function Dashboard() {
  const nav = useNavigate();
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);

  useEffect(() => { api.get('/projects').then(({ data }) => setProjects(data)).catch(() => {}); }, []);

  return (
    <div>
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="font-mono text-xs uppercase tracking-widest text-[#FF884D]">{greeting()}</div>
          <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight mt-1">{user?.name?.split(' ')[0] || 'Creator'}</h1>
        </div>
      </div>

      <button data-testid="create-hero-card" onClick={() => nav('/app/create')}
        className="group w-full text-left rounded-3xl border border-white/10 bg-gradient-to-br from-[#161926] to-[#0B0C12] p-8 sm:p-10 relative overflow-hidden grain hover:border-[#FF4D00]/40 transition-colors">
        <div className="absolute inset-0 brand-glow opacity-60" />
        <div className="relative flex flex-col sm:flex-row sm:items-center gap-6">
          <div className="grid place-items-center w-16 h-16 rounded-2xl bg-gradient-to-br from-[#FF4D00] to-[#8B5CF6] shadow-lg shadow-[#FF4D00]/20 shrink-0">
            <Plus className="w-8 h-8 text-white" />
          </div>
          <div className="flex-1">
            <div className="font-heading text-2xl font-bold">Create New Video</div>
            <div className="text-slate-400 mt-1">Upload a video and let AI shorten, revoice, score and caption it.</div>
          </div>
          <ArrowRight className="w-6 h-6 text-slate-500 group-hover:text-[#FF4D00] group-hover:translate-x-1 transition-all" />
        </div>
      </button>

      <div className="flex items-center justify-between mt-12 mb-5">
        <h2 className="font-heading text-xl font-bold">Recent Projects</h2>
        {projects.length > 0 && <button onClick={() => nav('/app/projects')} className="text-sm text-[#FF884D] hover:text-white">View all →</button>}
      </div>

      {projects.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-white/12 bg-[#0B0C12] p-12 text-center">
          <Film className="w-10 h-10 text-slate-600 mx-auto mb-4" />
          <div className="text-slate-300 font-medium">No projects yet</div>
          <div className="text-slate-500 text-sm mt-1">Your AI-edited videos will appear here.</div>
          <Button onClick={() => nav('/app/create')} className="rounded-full mt-6"><Sparkles className="w-4 h-4 mr-1" /> Create your first video</Button>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {projects.slice(0, 6).map((p) => <ProjectCard key={p.id} p={p} />)}
        </div>
      )}
    </div>
  );
}
